import {createContext} from "react";

interface Context {
  isAuth: string;
  setIsAuth: React.Dispatch<string>
}

export const Context = createContext<Context>({isAuth: '', setIsAuth: (value) => value });
